export enum TeamSide {
  Home = 'home',
  Away = 'away',
}
